module.exports = __webpack_public_path__ + "static/assets/9542a1ac8d24fc2db85b3a0f2a9a5677.svg";